// extracted by mini-css-extract-plugin
module.exports = {"totalCampaignOverviewStatistic":"Phishing_totalCampaignOverviewStatistic__1IVpC"};